import React from "react";
import VideoPlayer from "../Components/VideoPlayer/index";
import arrowRight from "../imgs/arrowRight.svg";
import "./ProverNetPage.css";
import AnimatedContent from "./animatedContent/AnimatedContent";
import useIsMobile from "../hooks/useIsMobile";


const videoUrl = "https://brevis-media-res.s3.us-west-1.amazonaws.com/website/mp4/provenet.mp4";

function ProverNetPage() {
  const { isMobile } = useIsMobile();
  const openLink = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="proverNetPage" id="proverNetPage">
        <AnimatedContent
          type="bottom"
          id={"Opening"}
          key={"Opening"}
          duration={800}
        >
             <div className="pageTitle">
        Coordinating the <span className="zkEcosystem">{`{ZK Ecosystem}`}</span>: ProverNet
      </div>
        </AnimatedContent>
     
      
      <div className="subtitle">
        <div className="des">
            A decentralized marketplace for ZK proof
        </div>
        <div className="des">
         generation, now live in mainnet beta.
         </div>
      </div>

      <div className="description" style={{marginTop: 24}}>
        <div className="des">Applications submit proof requests. Specialized provers compete to </div>
        <div className="des">fulfill them. The TODA auction mechanism matches jobs to hardware</div> 
        <div className="des">and clears pricing in real-time.</div>
      </div>
      
      <div className="description" style={{marginTop: 24}}>
        <div className="des">BREV token powers the economy as payment medium, staking</div>
        <div className="des">collateral, and governance.</div>
      </div>

      <div className="links">
        <div className="linkItem" onClick={() => openLink("https://github.com/brevis-network/prover-network-ops/blob/main/docs/run_prover_node.md")}>
          [ Register as a Prover ] <img src={arrowRight} alt="arrow" />
        </div>
        <div className="linkItem" onClick={() => openLink("https://github.com/brevis-network/prover-network-ops/blob/main/docs/request_proof.md")}>
          [ Submit Proof Requests ] <img src={arrowRight} alt="arrow" />
        </div>
        <div className="linkItem" onClick={() => openLink("https://get.celer.app/brevis/BrevisWhitePaper_09271015.pdf")}>
          [ Whitepaper ] <img src={arrowRight} alt="arrow" />
        </div>
      </div>

      <div style={{height: isMobile ? 200 : 500, overflow: "hidden"}}> 
        <div className="videoContainer">
          <VideoPlayer src={videoUrl} width="100%" height="100%" />
        </div>
      </div>
    </div>
  );
}

export default ProverNetPage;
